import Cookies from 'js-cookie'

const TokenKey = 'loginToken'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function get(key) {
  return Cookies.get(key)
}

export function set(key,value) {
  return Cookies.set(key, value)
}

export function remove(key) {
  return Cookies.remove(key)
}

export const subStateArr = {
  0: "待商家确认",
  3: "待签合同",
  11: "待付款",
  13: "已传凭证，待确认",
  21: "待发货",
  31: "待收货",
  32: "待付尾款",
  33: "尾款待商家确认",
  36: "赊销使用中",
  37: "赊销还款,待确认",
  40: "已关闭",
  50: "已完成",
}



// WEBPACK FOOTER //
// ./src/utils/auth.js